import React, { useMemo } from "react";
// import { ReactComponent as CalendarIcon } from "../../assets/img/common/calendar-icon.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/img/common/arrow-down-icon.svg";
import FieldErrorMsg from "./FieldErrorMsg";
import notify from "./notify";
import { projectTipsData } from "../../data/projects";
import Popover from "./Popover";
import { MdOutlineTipsAndUpdates } from "react-icons/md";
const defaultOptions = [
  { value: "val1", title: "title1" },
  { value: "val2", title: "title2" },
  { value: "val3", title: "title3" },
];

const SelectBox = ({
  containerClass = "w-40 ",
  selectContainerClass = "w-full h-9",
  iconSize = 24,
  arrowSize = 16,
  options = defaultOptions,
  id,
  onChange,
  value,
  title,
  placeholder,
  disabled = false,
  formik,
  onBlur = () => {},
  description = "",
  icons,
  currentIcon,
  tipsId,
  required,
}) => {
  const error = () => {
    if (formik && formik.touched?.[id] && formik.errors?.[id]) return true;
    else return false;
  };

  const icon = useMemo(() => {
    if (icons) {
      return icons?.[currentIcon];
    }
  }, [icons, currentIcon]);
  return (
    <div
      className={`${containerClass} flex flex-col font-roboto relative ${
        disabled && "opacity-70"
      }`}
      onClick={() => {
        if (disabled) {
          notify(
            `You cannot change the ${title} after the project is published.`
          );
        }
      }}
    >
      {title && (
        <label htmlFor={id} className=" pl-2 mb-1">
          <div className="flex items-end ">
            <h3 className="font-bold text-sm mb-0.5">{title}</h3>
            {required && <span className="text-red-500 ml-1">*</span>}
            {projectTipsData?.[tipsId ?? id] && (
              <Popover
                detailElement={projectTipsData?.[tipsId ?? id]}
                title={title}
                index={0}
              >
                <MdOutlineTipsAndUpdates className="text-lg mlg:text-xl text-primary ml-1 -mt-2" />
              </Popover>
            )}
          </div>
          {description && <p className="text-xs mb-1">{description}</p>}
        </label>
      )}
      <div
        className={`${selectContainerClass}  w-full relative cursor-pointer  `}
      >
        {/* <CalendarIcon className="absolute left-2 " /> */}
        <span className="h-full absolute right-3 top-0 flex items-center pointer-events-none">
          {icons && icon && (
            <img
              src={icon}
              alt={currentIcon}
              style={{ width: `${iconSize}px` }}
              className="mr-2"
            />
          )}
          <ArrowDownIcon style={{ width: `${arrowSize}px` }} />
        </span>

        <select
          onChange={(e) => {
            if (onChange) onChange(e);
            else {
              formik.handleChange(e);
              formik?.setFieldTouched(id, false);
            }
          }}
          value={value}
          disabled={disabled}
          className={`w-full h-full rounded-[10px] text-sm font-[poppins] pl-3 pr-6  focus:border-primary  focus:text-primary custom-select-box focus:border-2 cursor-pointer bg-transparent custom-select-box transition-all duration-300 ${
            value === "" && "text-custom-gray-600"
          } ${
            error()
              ? " border-2 border-red-500"
              : " border border-custom-gray-600"
          } ${disabled && "pointer-events-none"}`}
          id={id}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option value={option.value} key={id + index}>
              {option.title}
            </option>
          ))}
        </select>
      </div>
      {formik && <FieldErrorMsg formik={formik} id={id} />}
    </div>
  );
};

export default SelectBox;
